import styled from 'styled-components';

export const StyledResetPasswordPage = styled.div`
  width: 385px;
  margin: 110px auto 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  .reset-password__logo {
    width: 44px;
    height: 44px;
  }
  .reset-password__title {
    margin-top: 8px;
    ${({ theme }) => theme.typography.appTitle};
  }
  .reset-password__text {
    margin-top: 72px;
    ${({ theme }) => theme.typography.signInText};
  }
  .reset-password-form {
    margin-top: 30px;
    width: 100%;
    display: flex;
    flex-direction: column;
    .reset-password-form__label {
      margin-top: 20px;
      ${({ theme }) => theme.typography.formInput}
    }
    .reset-password-form__input {
      height: 50px;
      padding-left: 15px;
      margin-top: 8px;
      border: 2px solid;
      border-radius: 10px;
      border-color: ${({ theme }) => theme.colors.grey3};
      ${({ theme }) => theme.typography.formInput}
      &:focus {
        border-color: ${({ theme }) => theme.colors.green1};
        outline: none;
      }
    }
    .reset-password-form__button {
      margin-top: 100px;
      height: 54px;
      border-radius: 10px;
      background-color: ${({ theme }) => theme.colors.green1};
      ${({ theme }) => theme.typography.formButton}
      color: white;
      cursor: pointer;
    }

    .reset-password-form__sign-in {
      margin-top: 15px;
      cursor: pointer;
      text-align: right;
      text-decoration: underline;
    }
  }
`;
